/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class FormCodeFunctionService extends services.DataService<Wars.Domain.Model.FormCodeFunction> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public createFormCodeFunction(): Wars.Domain.Model.FormCodeFunction {
            return this.createNewEntity<Wars.Domain.Model.FormCodeFunction>("FormCodeFunction");
        }

        public getFieldsFormCodeFunction(fieldId): angular.IPromise<Wars.Domain.Model.FormCodeFunction> {
            const query = this.breezeModule.EntityQuery
                .from("FormCodeFunctions")
                .where("field_id", "==", fieldId);

                return this.fetch(query);
        }
    }
}

warsApp.registerService('FormCodeFunctionService', ['breeze', '$q']);